module.exports = __webpack_public_path__ + "fonts/font.27d49bd.woff2";